import WithRender from "../../templates/imageEditorGalleries/imageEditorGallery.html";
import { mapActions, mapGetters } from "vuex";
import "justifiedGallery/dist/css/justifiedGallery.css";
import "justifiedGallery/dist/js/jquery.justifiedGallery";
import * as R from "ramda";
import { Drag } from "vue-drag-drop";

export default WithRender({
  components: {
    drag: Drag
  },
  props: ["items", "hideDelete"],
  data: () => {
    return {
      animationTimes: R.times(R.identity, 23)
    };
  },
  computed: {},

  methods: {
    ...mapActions(["deleteCustomerImage"]),
    deleteImageHandler(uuid) {
      this.deleteCustomerImage(uuid);
    }
  },
  mounted() {
    $(this.$refs.imageEditorGallery).justifiedGallery({
      margins: 10,
      rowHeight: 100
    });
  },
  updated: function () {
    //$(this.$refs.imageEditorGallery).justifiedGallery("norewind");
    $(this.$refs.imageEditorGallery).justifiedGallery();
  }
});
